import {Mutation} from '@apollo/react-components';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {Button, Col} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import ConfirmModal from '../../../common/components/ConfirmModal';
import Error from '../../../common/components/Error/Error';
import {GRAPHQL_MUTATION_DELETE_USER} from '../../../common/queries/users';
import UpdateUser from './UpdateUser';
import SendActivationMail from '../../../common/components/SendActivationMail';

const FlexRow = styled(Col)`
  display: flex;
  align-items: center;
`;

const displayError = t => () => <Error error={t('errorUpdating')}/>;

const UserRowAction = ({t, user}) => {
  const {id, isDeleted} = user;
  return (
    <FlexRow>
      <div>
        <UpdateUser user={user}/>
      </div>
      <div>
        <Mutation
          mutation={GRAPHQL_MUTATION_DELETE_USER}
          refetchQueries={['users']}
          variables={{userId: id}}
        >
          {(mutation, {loading}) => (
            <ConfirmModal
              title={t('deleteUser')}
              mutation={mutation}
              displayError={displayError(t)}
              size={'sm'}
              confirmBtn={'yes'}
              cancelBtn={'no'}
            >
              {askConfirmation => (
                <div className="btn-disable">
                  <Button hidden={isDeleted} className="btn-update btn-update-disable" onClick={askConfirmation}>
                    <FontAwesomeIcon icon={faTimes} color={isDeleted ? 'grey' : 'red'} size="sm" />
                  </Button>
                  <span hidden={!isDeleted}>
                    {t('accountDeleted')}
                  </span>
                </div>
              )}
            </ConfirmModal>
          )}
        </Mutation>
      </div>
      <SendActivationMail user={user}/>
    </FlexRow>
  );
};

UserRowAction.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isDeleted: PropTypes.bool.isRequired,
  }).isRequired,
};

export default withTranslation('user')(UserRowAction);
